<hr class="section-separator" />
<div *ngIf="reviewsQueryResult$ | async as reviewsQueryResult">
  <div *ngIf="reviewsQueryResult.data as reviews">
    <label *ngIf="reviews.length; else noReviews" class="_Djaqe1">
      <h5>Reviews</h5>
      <section *ngIf="reviewAnalytics$ | async as reviewAnalytics">
        <div class="results-wrap">
          <!-- review analytics/totals.average -->
          <h3>
            {{ toSignificatFigures(reviewAnalytics.averageRating) }}
            <span>/5</span>
          </h3>
          <div class="rating">
            <!-- <i *ngFor="let star of getReviewStars(reviewAnalytics.averageRating)" [ngClass]="star">
            </i> -->
            <app-rating-stars-label [rating]="reviewAnalytics.averageRating"></app-rating-stars-label>
          </div>
          <!-- total ratings -->
          <label class="_wej2br3">
            {{ reviewAnalytics.numberOfReviews }} Rating(s)
          </label>
        </div>
        <div class="ratings-wrap">
          <label class="_2u3Gsj">
            <p class="_shGu2hv">Condition</p>
            <mat-progress-bar class="rating-bar" mode="determinate"
              [value]="(reviewAnalytics.averageCondition/5) * 100">
            </mat-progress-bar>
            <!-- condition average rating -->
            <p class="_Jejweq">
              {{ toSignificatFigures(reviewAnalytics.averageCondition) }}/5
            </p>
          </label>
          <label class="_2u3Gsj">
            <p class="_shGu2hv">Communication</p>
            <mat-progress-bar class="rating-bar" mode="determinate"
              [value]="(reviewAnalytics.averageCommunication/5) * 100"></mat-progress-bar>
            <!-- Communication average rating -->
            <p class="_Jejweq">
              {{ toSignificatFigures(reviewAnalytics.averageCommunication) }}/5
            </p>
          </label>
          <label class="_2u3Gsj">
            <p class="_shGu2hv">Value for Money</p>
            <mat-progress-bar class="rating-bar" mode="determinate"
              [value]="(reviewAnalytics.averageValueForMoney/5) * 100"></mat-progress-bar>
            <!-- Value for Money average rating -->
            <p class="_Jejweq">
              {{ toSignificatFigures(reviewAnalytics.averageValueForMoney) }}/5
            </p>
          </label>
        </div>
      </section>
      <br>
      <div class="client-review-wrap">
        <div>
          <div *ngFor="let review of reviews" class="client-review">
            <section>
              <div class="_Dh3n3" [ngStyle]="getImageStyle(getUserPhotoUrl(review) | imageUrl | async)">
                <i class="fa fa-info-circle"></i>
              </div>
              <div class="_sFen3">
                <label class="_fbe25b">{{ getReviewUserDisplayName(review) }}</label>
                <label class="_fbe24b">{{ getReviewDate(review) }}</label>
              </div>
            </section>
            <label>
              {{ getReviewComment(review) }}
            </label>
          </div>
        </div>

        <mat-paginator class="reviews-paginate" *ngIf="reviewsPagination$ | async as reviewPagination" [pageIndex]="reviewPagination.page"
          [length]="reviewsQueryResult.size" [pageSize]="reviewPagination.size"
          (page)="handleReviewPaginatorChange($event)">
        </mat-paginator>
      </div>
    </label>
    <ng-template #noReviews>
      <div class="row">
        <div class="col-lg-12">
          <h5>Reviews</h5>
          <section class="empty-section-review">
            <svg xmlns="http://www.w3.org/2000/svg" class="icon" viewBox="0 0 1024 1024" style="height: 25px;fill: var(--primary_color);">
              <path d="M885.9 533.7c16.8-22.2 26.1-49.4 26.1-77.7 0-44.9-25.1-87.4-65.5-111.1a67.67 67.67 0 0 0-34.3-9.3H572.4l6-122.9c1.4-29.7-9.1-57.9-29.5-79.4A106.62 106.62 0 0 0 471 99.9c-52 0-98 35-111.8 85.1l-85.9 311H144c-17.7 0-32 14.3-32 32v364c0 17.7 14.3 32 32 32h601.3c9.2 0 18.2-1.8 26.5-5.4 47.6-20.3 78.3-66.8 78.3-118.4 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7-.2-12.6-2-25.1-5.6-37.1zM184 852V568h81v284h-81zm636.4-353l-21.9 19 13.9 25.4a56.2 56.2 0 0 1 6.9 27.3c0 16.5-7.2 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 0 1 6.9 27.3c0 16.5-7.2 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 0 1 6.9 27.3c0 22.4-13.2 42.6-33.6 51.8H329V564.8l99.5-360.5a44.1 44.1 0 0 1 42.2-32.3c7.6 0 15.1 2.2 21.1 6.7 9.9 7.4 15.2 18.6 14.6 30.5l-9.6 198.4h314.4C829 418.5 840 436.9 840 456c0 16.5-7.2 32.1-19.6 43z"/>
            </svg>
            <div class="empty-section-review-content">
              <p style="padding-top: 4px;">No reviews added yet!</p>
            </div>
          </section>
        </div>
      </div>
    </ng-template>
  </div>
</div>